// import types
import { AskRoundSettingsResponse } from 'generated/index';
import { AIMatchForm } from './AIMatch.types';
import { AIMatchSettingsType } from 'components/types';

export const defaultRoundValues: AskRoundSettingsResponse = {
  minutesBeforeStart: 0,
  minimalMinutesOfAdvantageBeforeNext: 0,
  includeFunctionPreference1: false,
  includeFunctionPreference2: false,
  includeOwn: false,
  includeShared: false,
  includePreference1: false,
  includePreference2: false,
  includeFlex: false,
  includeFlexWithPreference1: false,
  includeFlexWithPreference2: false,
  includeDeployableAsFlex: false,
  includeDeployableAsFlexWithPreference1: false,
  includeDeployableAsFlexWithPreference2: false,
  overlapMargin: 0,
  responseActionType: 'CONNECT'
};

export const defaultSettingValues: AIMatchForm = {
  [AIMatchSettingsType.TIMES]: [],
  [AIMatchSettingsType.BEFORE_START_LIMIT]: '00:00',
  [AIMatchSettingsType.ROUND_MINUTES_BEFORE_START_LIMIT]: '00:00',
  [AIMatchSettingsType.FLEX_ENABLED]: false,
  [AIMatchSettingsType.NON_FLEX_ENABLED]: false,
  rounds: []
};
